import { styles } from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import TextfieldNumber from "../textfields/textfield.number";
import React from "react";
import {ToolTipPerso} from "../selects/tooltip_perso";
import BadgeNouveau from "../texts/BadgeNouveau";

const AccessoiresQuestion = (props) => {
  return (
    <div>
      <div className="cardRow">
        <div className="badge-hover-parent" style={{...styles.cardElemVerticalyCenter, display: 'flex', alignItems: 'center', flexWrap: 'wrap', whiteSpace: 'normal', gap: '2px', minWidth: 0}}>
          Souhaitez vous fixer librement le % des accessoires à prévoir ?
          <ToolTipPerso 
              title={
                  "Par défaut (si la réponse est “Non”), les accessoires sont compris et évalués au bordereau à concurrence de 20% du capital emprunté (hypothèque légale de prêteur de deniers et/ou HC). Si la réponse est “Oui” le % que vous aurez indiqué librement s’appliquera"
              }
          />
          <BadgeNouveau cliquable={false}/>
        </div>
        <div>
          <ButtonYesno
            handleChange={props.handleChange}
            setter={props.setModifAccessoires}
            reduxKey={"modif_accessoires"}
            defaultValue={0}
          />
        </div>
      </div>

      {parseInt(props.modifAccessoires) === 1 ? (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Indiquer le taux des accessoires (%) :</div>
          <TextfieldNumber
            handleChange={props.handleChange}
            type={"number"}
            placeholder={"Indiquer le taux"}
            setter={props.setTauxAccessoires}
            reduxKey={"taux_accessoires"}
            max={"100"}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AccessoiresQuestion;
